export default __webpack_public_path__ + "static/DevOps-d9039ae8f4c6194ad34f93b2e5b807c2.png";